import React, { useState, useEffect } from "react";
import KPI from "./KPI";
import RankingTiposPago from "./rankingtipospago";
import TopMotivos from "./TopMotivos";
import PagosPorMesChart from "./PagosPorMesChart";
import MembretesPorEstadoChart from "./MembretesPorEstadoChart";
import DeudasDetalleTable from "./DeudasDetalleTable";
import ExportarExcel from "./ExportarExcel";
import { fetchDashboard } from "../api/reportes";

const Dashboard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = async () => {
      const res = await fetchDashboard();
      console.log("Respuesta completa de fetchDashboard():", res);
      setData({
        ...res,
        
      });
    };
    load();
  }, []);

  if (!data) return <div className="text-center mt-5">Cargando...</div>;

  return (
    <div className="container-fluid py-4" style={{ background: "#f4f6f9" }}>
      
      {/* ===== KPIs ===== */}
      <section className="mb-4">
        <h5 className="mb-3 fw-bold text-secondary">KPIs</h5>
        <div className="row g-4">
          
          <KPI title="Total Citas" value={data.total_citas || 0} gradient="linear-gradient(90deg, #4e73df, #1cc88a)" color="#4e73df" />
          <KPI title="Ingresos" value={`$${data.ingresos || 0}`} gradient="linear-gradient(90deg, #4e73df, #1cc88a)" color="#1cc88a" />
          <KPI title="Deudas" value={`$${data.deudas || 0}`} gradient="linear-gradient(90deg, #4e73df, #1cc88a)" color="#dc3545" />
          <KPI title="Total Clientes" value={data.total_clientes || 0} gradient="linear-gradient(90deg, #4e73df, #1cc88a)" color="#6f42c1" />
          <KPI title="Citas Atendidas" value={data.citas_atendidas || 0} gradient="linear-gradient(90deg, #4e73df, #1cc88a)" color="#28a745" />
          <KPI title="Citas Canceladas" value={data.citas_canceladas || 0} gradient="linear-gradient(90deg, #4e73df, #1cc88a)" color="#ffc107" />
          {/*<KPI title="Citas Reprogramadas" value={data.citas_reprogramadas || 0} gradient="linear-gradient(90deg, #4e73df, #1cc88a)" color="#17a2b8" />*/}
        </div>
      </section>

      {/* ===== Top Rankings ===== */}
      <section className="mb-4">
        <h5 className="mb-3 fw-bold text-secondary">Top Rankings</h5>
        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-3 bg-white rounded shadow-sm h-100">
              <TopMotivos motivos={data.top_motivos || []} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="p-3 bg-white rounded shadow-sm h-100">
              <RankingTiposPago />
            </div>
          </div>
        </div>
      </section>

      {/* ===== Análisis Gráfico ===== */}
      <section className="mb-4">
        <h5 className="mb-3 fw-bold text-secondary">Análisis Gráfico</h5>
        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-3 bg-white rounded shadow-sm h-100">
              <PagosPorMesChart pagos={data.pagos_mes || []} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="p-3 bg-white rounded shadow-sm h-100">
              <MembretesPorEstadoChart membretes={data.membretes_estado || []} />
            </div>
          </div>
        </div>
      </section>

      {/* ===== Detalle de Deudas ===== */}
      <section>
        <h5 className="fw-bold text-secondary mb-3">Detalle de Deudas y Datos</h5>
        <div className="p-3 bg-white rounded shadow-sm mb-3">
          <DeudasDetalleTable deudas={data.deudas_detalle || []} />
        </div>
        <div className="text-start">
          <ExportarExcel refrescarDatos={() => fetchDashboard().then(setData)} />
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
